import { planomassmarket } from "./planomassmarket";
import { comments } from "./comments";

export const events = {
    namespaced: true,
    modules: {
        planomassmarket,
        comments
    }
};



// WEBPACK FOOTER //
// ./src/store/events/events.js